// Remove dependencies used by angular modules from the global scope
delete window.moment;
